import AvatarsContainer from "../../template/js/avatars-container";

export default class HomePicksHandler {

    constructor(signInModal) {
        this.input = $("#searchPeopleInput");
        this.avatarsContainer = new AvatarsContainer();
        this.signInModal = signInModal;
    }

    init() {
        const self = this;
        let arr = [];
        do {
            let num = Math.floor(Math.random() * 9);
            arr.push(num);
            arr = arr.filter((item, index) => {
                return arr.indexOf(item) === index
            });
        } while (arr.length < 5);
        $(".home-avatar").each(function () {
            $(this).attr("src", self.avatarsContainer.coloredAvatars[arr[0]].src);
            arr.shift();
        });
        self.input.on("click focus touch", function (e) {
            e.preventDefault();
            self.signInModal.show("Please sign in with LinkedIn to start scouting")
        });
    }
}